export default __webpack_public_path__ + "static/jasmin-zine-1645f551f1815d658d004b5414e400bd.png";